import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    productRegistrations: [],
    productRegistration: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.filter = {
        keyword: '',
      };
      state.productRegistrations = [];
      state.productRegistrations = null;
    },

    SET_MEMBER_PRODUCT_REGISTRATIONS(state, data) {
      state.productRegistrations = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    find({ commit, state }, id) {
      let url = `/members/${id}/product_regisetrations?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('Member'));
          return response.body;
        })
        .then((response) => {
          commit('SET_MEMBER_PRODUCT_REGISTRATIONS', response);
          return response;
        });
    },
  },
};
